import {fontWeights} from './styleVariables';

interface PaletteR4Color {
  readonly lowlight?: string;
  readonly base: string;
  readonly highlight?: string;
  readonly tint?: string;
}

export enum PaletteR4ColorsEnum {
  WHITE = 'white',
  FRONT_RED = 'red',
  FRONT_BLACK = 'black',
  ORANGE = 'orange',
  DARK_BLUE = 'dark_blue',
  BLUE = 'blue',
  GREEN = 'green',
  YELLOW = 'yellow',
  GRAY = 'gray'
}

type PaletteR4 = {readonly [T in PaletteR4ColorsEnum]: PaletteR4Color};

export const paletteR4: PaletteR4 = {
  [PaletteR4ColorsEnum.FRONT_RED]: {
    lowlight: '#CC0049',
    base: '#FF0057',
    highlight: '#FFD4E6',
    tint: '#FFE8F0'
  },
  [PaletteR4ColorsEnum.ORANGE]: {
    lowlight: '#DD3C00',
    base: '#FF5800',
    highlight: '#FFE1CB'
  },
  [PaletteR4ColorsEnum.YELLOW]: {
    lowlight: '#FFB700',
    base: '#FFCF00',
    highlight: '#FFFADD'
  },
  [PaletteR4ColorsEnum.GREEN]: {
    lowlight: '#008B4A',
    base: '#00D47D',
    highlight: '#ACF8E2',
    tint: '#DCFFF3'
  },
  [PaletteR4ColorsEnum.BLUE]: {
    lowlight: '#006EB2',
    base: '#00BFFF',
    highlight: '#B0F1FC',
    tint: '#D9F8FF'
  },
  [PaletteR4ColorsEnum.FRONT_BLACK]: {
    base: '#001B38'
  },
  [PaletteR4ColorsEnum.GRAY]: {
    base: '#808080',
    highlight: '#F3F2F0',
    tint: '#F8F8F8'
  },
  // Not defined in palette but used in components
  [PaletteR4ColorsEnum.WHITE]: {
    base: '#FFF'
  },
  // Not defined in palette but used in components
  [PaletteR4ColorsEnum.DARK_BLUE]: {
    base: '#BDC9D6'
  }
};

export const paletteR4Secondary: PaletteR4 = {
  [PaletteR4ColorsEnum.FRONT_RED]: {
    lowlight: '#CC0049',
    base: '#FF0057',
    highlight: '#FFD4E6',
    tint: '#FFE8F0'
  },
  [PaletteR4ColorsEnum.ORANGE]: {
    lowlight: '#DD3C00',
    base: '#FF5800',
    highlight: '#FFE1CB',
    tint: '#FFF0E3'
  },
  [PaletteR4ColorsEnum.YELLOW]: {
    lowlight: '#FFB700',
    base: '#FFCF00',
    highlight: '#FFFADD',
    tint: '#FFFCEC'
  },
  [PaletteR4ColorsEnum.GREEN]: {
    lowlight: '#008B4A',
    base: '#00D47D',
    highlight: '#ACF8E2',
    tint: '#DCFFF3'
  },
  [PaletteR4ColorsEnum.BLUE]: {
    lowlight: '#006EB2',
    base: '#00BFFF',
    highlight: '#B0F1FC',
    tint: '#D9F8FF'
  },
  [PaletteR4ColorsEnum.FRONT_BLACK]: {
    base: '#001B38'
  },
  [PaletteR4ColorsEnum.GRAY]: {
    base: '#808080',
    highlight: '#F3F2F0',
    tint: '#FAFAFA'
  },
  // Not defined in palette but used in components
  [PaletteR4ColorsEnum.WHITE]: {
    base: '#FFF'
  },
  // Not defined in palette but used in components
  [PaletteR4ColorsEnum.DARK_BLUE]: {
    base: '#BDC9D6'
  }
};

export const fontFamiliesR4 = {
  frontPageTitle: `
  'Quincy CF',
  Helvetica,
  Arial,
  sans-serif
  `,
  title: `
  'Roobert',
  Helvetica,
  Arial,
  sans-serif
  `,
  body: `
  'Roobert',
  Helvetica,
  Arial,
  sans-serif
  `
};

export const fontSizesMixinsQuincyR4 = {
  h1: () => `
    font-family: ${fontFamiliesR4.frontPageTitle};
    font-weight: ${fontWeights.medium};
    font-size: 62px;
    line-height: 70px;
    letter-spacing: 0.01em;
    font-feature-settings: 'salt' on;
  `
};

export const fontSizesMixinsQuincyMobileR4 = {
  h1: () => `
    font-family: ${fontFamiliesR4.frontPageTitle};
    font-weight: ${fontWeights.medium};
    font-size: 38px;
    line-height: 112%;
    letter-spacing: 0.01em;
    font-feature-settings: 'salt' on;
  `
};

export const fontSizesMixinsR4 = {
  h1: () => `
    font-family: ${fontFamiliesR4.body};
    font-weight: ${fontWeights.semibold};
    font-size: 80px;
    line-height: 110%;
    letter-spacing: -0.01em;
    font-feature-settings: 'salt' on;
  `,
  h2: () => `
    font-family: ${fontFamiliesR4.body};
    font-weight: ${fontWeights.semibold};
    font-size: 49px;
    line-height: 118%;
    letter-spacing: -0.01em;
    font-feature-settings: 'salt' on;
  `,
  h3: () => `
    font-family: ${fontFamiliesR4.body};
    font-weight: ${fontWeights.semibold};
    font-size: 32px;
    line-height: 118%;
    letter-spacing: -0.01em;
    font-feature-settings: 'salt' on;
  `,
  h4: () => `
    font-family: ${fontFamiliesR4.body};
    font-weight: ${fontWeights.semibold};
    font-size: 24px;
    line-height: 100%;
    letter-spacing: -0.01em;
    font-feature-settings: 'salt' on;
  `,
  h5: () => `
    font-family: ${fontFamiliesR4.body};
    font-weight: ${fontWeights.bold};
    font-size: 16px;
    line-height: 160%;
    font-feature-settings: 'salt' on;
  `,
  h6: () => `
    font-family: ${fontFamiliesR4.body};
    font-weight: ${fontWeights.bold};
    font-size: 16px;
    line-height: 125%;
    letter-spacing: 0.08em;
    font-feature-settings: 'titl' on, 'salt' on, 'ss04' on;
  `,
  h7: () => `
    font-family: ${fontFamiliesR4.body};
    font-weight: ${fontWeights.semibold};
    font-size: 12px;
    line-height: 160%;
    letter-spacing: 0.1em;
    font-feature-settings: 'titl' on;
  `,
  p1: () => `
    font-family: ${fontFamiliesR4.body};
    font-weight: ${fontWeights.normal};
    font-size: 24px;
    line-height: 142%;
    font-feature-settings: 'salt' on;
  `,
  p2: () => `
    font-family: ${fontFamiliesR4.body};
    font-weight: ${fontWeights.normal};
    font-size: 16px;
    line-height: 150%;
    font-feature-settings: 'salt' on;
  `,
  p3: () => `
    font-family: ${fontFamiliesR4.body};
    font-weight: ${fontWeights.normal};
    font-size: 14px;
    line-height: 143%;
    font-feature-settings: 'salt' on;
  `,
  p4: () => `
    font-family: ${fontFamiliesR4.body};
    font-weight: ${fontWeights.normal};
    font-size: 12px;
    line-height: 133%;
    font-feature-settings: 'titl' on, 'salt' on, 'ss04' on;
  `
};

export const fontSizesMixinsMobileR4 = {
  h1: () => `
    font-family: ${fontFamiliesR4.body};
    font-weight: ${fontWeights.semibold};
    font-size: 38px;
    line-height: 120%;
    letter-spacing: -0.01em;
  `,
  h2: () => `
    font-family: ${fontFamiliesR4.body};
    font-weight: ${fontWeights.semibold};
    font-size: 32px;
    line-height: 118%;
    letter-spacing: -0.01em;
    font-feature-settings: 'salt' on;
  `,
  h3: () => `
    font-family: ${fontFamiliesR4.body};
    font-weight: ${fontWeights.semibold};
    font-size: 24px;
    line-height: 124%;
    letter-spacing: -0.01em;
    font-feature-settings: 'salt' on;
  `,
  h4: () => `
    font-family: ${fontFamiliesR4.body};
    font-weight: ${fontWeights.bold};
    font-size: 16px;
    line-height: 130%;
    font-feature-settings: 'salt' on;
  `,
  h5: () => `
    font-family: ${fontFamiliesR4.body};
    font-weight: ${fontWeights.bold};
    font-size: 14px;
    line-height: 125%;
    letter-spacing: 0.08em;
    font-feature-settings: 'titl' on, 'salt' on, 'ss04' on;
  `,
  h6: () => `
    font-family: ${fontFamiliesR4.body};
    font-weight: ${fontWeights.semibold};
    font-size: 12px;
    line-height: 160%;
    letter-spacing: 0.1em;
    font-feature-settings: 'titl' on;
  `,
  p1: () => `
    font-family: ${fontFamiliesR4.body};
    font-weight: ${fontWeights.normal};
    font-size: 18px;
    line-height: 144%;
    font-feature-settings: 'salt' on;
  `,
  p2: () => `
    font-family: ${fontFamiliesR4.body};
    font-weight: ${fontWeights.normal};
    font-size: 16px;
    line-height: 150%;
    font-feature-settings: 'titl' on, 'salt' on, 'ss04' on;
  `,
  p3: () => `
    font-family: ${fontFamiliesR4.body};
    font-weight: ${fontWeights.normal};
    font-size: 14px;
    line-height: 143%;
    font-feature-settings: 'salt' on;
  `,
  p4: () => `
    font-family: ${fontFamiliesR4.body};
    font-weight: ${fontWeights.normal};
    font-size: 13px;
    line-height: 153%;
    font-feature-settings: 'salt' on;
  `
};
